import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { MuiTelInput } from 'mui-tel-input';
export const FormMuiTelInput = ({
	name,
	control,
	label,
	rules,
	getCountryFromAddress,
	isPhoneNumPresent
}: {
	name: string;
	control: Control<any, any>;
	label: string;
	rules?: Record<string, unknown>;
	getCountryFromAddress?: any;
	isPhoneNumPresent?: string;
}) => {
	return (
		<Controller
			name={name}
			control={control}
			rules={rules}
			render={({ field: { onChange, value }, fieldState: { error } }) => (
				<MuiTelInput
					helperText={error ? error.message : null}
					size="small"
					error={!!error}
					onChange={onChange}
					// disabled={!getCountryFromAddress}
					value={value}
					fullWidth
					label={label}
					variant="outlined"
					defaultCountry={!isPhoneNumPresent ? getCountryFromAddress : undefined}
				/>
			)}
		/>
	);
};
